import type { ReactNode } from "react";
import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";

interface MovieGridProps {
  movies: Movie[];
  showSynopsis?: boolean;
  empty?: ReactNode;
}

export default function MovieGrid({ movies, showSynopsis = false, empty }: MovieGridProps) {
  if (!movies.length) {
    return <>{empty}</>;
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 md:gap-5">
      {movies.map((movie) => (
        <MovieCard key={movie.id} movie={movie} showSynopsis={showSynopsis} />
      ))}
    </div>
  );
}